import React, { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Button from '../../components/common/Button/Button';
import PageContainer from '../../components/common/PageContainer/PageContainer';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import StickyHeader from '../../components/common/StickyHeader/StickyHeader';
import { useBreadcrumbs } from '../../contexts/BreadcrumbContext';
import { getHelpDocumentById } from './helpDocuments';
import styles from './Help.module.css';

const HelpDocumentPage: React.FC = () => {
  const { documentId } = useParams<{ documentId: string }>();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumbs();
  const document = documentId ? getHelpDocumentById(documentId) : null;

  useEffect(() => {
    if (!document) {
      setBreadcrumbs([{ label: 'Ajuda', path: '/ajuda' }]);
      return () => setBreadcrumbs([]);
    }

    setBreadcrumbs([
      { label: 'Ajuda', path: '/ajuda' },
      { label: document.title },
    ]);

    return () => setBreadcrumbs([]);
  }, [document, setBreadcrumbs]);

  if (!document) {
    return <Navigate to="/ajuda" replace />;
  }

  return (
    <PageContainer className={styles.page}>
      <StickyHeader
        onBack={() => navigate('/ajuda')}
        actions={(
          <Button
            type="button"
            variant="ghost"
            size="small"
            icon="open_in_new"
            onClick={() => window.open(document.pdfUrl, '_blank', 'noopener,noreferrer')}
          >
            Abrir PDF
          </Button>
        )}
      />

      <PageHeader title={document.title} subtitle={document.description} />

      <div className={styles.viewer}>
        <iframe
          className={styles.viewerFrame}
          src={document.pdfUrl}
          title={document.title}
          allow="fullscreen"
        />
      </div>
    </PageContainer>
  );
};

export default HelpDocumentPage;
